import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Journal = lazy(() => import("@/pages/Journal"));

export const Route = createFileRoute("/_public/journal/")({
  head: () => pageHead({ path: "/journal", title: "Amorette Journal — Stories from Curated Dining Experiences", description: "Explore stories from our curated dining experiences, city spotlights, and official announcements from the Amorette community.", canonical: false }),
  component: Journal,
});
